<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex lg12>
          <v-card>
            <br />
            <v-toolbar card color="white">
              <v-toolbar-title class="indigo--text"
                >Resumen de Acomodaciones</v-toolbar-title
              >
            </v-toolbar>
            <v-layout justify-center>
              <v-flex xs12 md3>
                <v-select
                  v-model="regionValue"
                  :items="regionSelect"
                  label="Region"
                  item-text="name"
                  item-value="code"
                ></v-select>
              </v-flex>
              <v-flex xs12 md3>
                <v-select
                  v-model="comunaValue"
                  :items="comunaSelect"
                  label="Comuna"
                  item-text="name"
                  item-value="code"
                ></v-select>
              </v-flex>
              <v-flex xs12 md3>
                <v-select
                  v-model="nivelValue"
                  :items="nivelSelect"
                  label="Nivel"
                  item-text="name"
                  item-value="code"
                ></v-select>
              </v-flex>
              <v-btn
                fab
                dark
                color="teal"
                title="Filtrar detalle"
                @click="filterGra()"
              >
                <v-icon dark>filter_list</v-icon>
              </v-btn>
              <!-- BOTON NO INCLUIDO EN DISEÑO DEBERIA ESTAR -->
              <v-btn
                fab
                dark
                color="red darken-4"
                title="Limpiar filtros"
                @click="clear()"
              >
                <v-icon dark>clear_all</v-icon>
              </v-btn>
            </v-layout>
            <v-layout>
              <v-flex>
                <div>
                  <v-layout row wrap>
                    <v-flex lg12 sm12 xs12>
                      <div v-if="loading">
                        <loading></loading>
                      </div>

                      <v-widget
                        class="px-0"
                        :key="indexChart"
                        :title="tituloGraficaRegion"
                        content-bg="white"
                      >
                        <div slot="widget-content">
                          <e-chart
                            :path-option="[
                              ['dataset.source', res],
                              [
                                'color',
                                [color.lightBlue.base, color.orange.base],
                              ],
                              ['legend.show', true],
                              ['xAxis.axisLabel.show', true],
                              ['yAxis.axisLabel.show', true],
                              ['grid.left', '2%'],
                              ['grid.bottom', '5%'],
                              ['grid.right', '3%'],
                              ['series[0].type', 'bar'],
                              ['series[0].areaStyle', {}],
                              ['series[0].smooth', true],
                              ['series[1].type', 'bar'],
                              ['series[1].areaStyle', {}],
                              ['series[1].smooth', true],
                            ]"
                            height="400px"
                            width="100%"
                          ></e-chart>
                        </div>
                      </v-widget>
                    </v-flex>
                  </v-layout>
                </div>
              </v-flex>
            </v-layout>
            <v-flex style="text-align: center">
              <v-btn color="primary" @click="downloadComplete()"
                >Descarga Completa</v-btn
              >
            </v-flex>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import EChart from "@/components/chart/echart";
import VWidget from "@/components/VWidget";
import Material from "vuetify/es5/util/colors";
import CircleStatistic from "@/components/widgets/statistic/CircleStatistic";

export default {
  name: "porcentaje-avance",

  components: {
    VWidget,
    EChart,
    Loading,
    CircleStatistic,
  },

  props: {},

  data() {
    return {
      loading: false,
      color: Material,
      loading: false,
      proveedor: {},
      rowsTable: [20],
      tabSelect: "",
      activeTab: "",
      index: "",
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      usuarioLogged: "",
      gridDocumento: 20,
      idEstado: "",
      idContrato: "",
      tabSelected: "",
      regionValue: null,
      regionSelect: [],
      comunaValue: null,
      comunaSelect: [],
      nivelValue: null,
      nivelSelect: [],
      indexChart: 0,
      res: [],
      datosGrafico: null,
    };
  },

  mounted() {},
  created() {
    this.tabSelected = this.$store.getters.subTabSelectedStored;
    this.usuarioLogged = this.$store.getters.userLogged;
    this.tipeCenter = this.$store.getters.subTabSelectedStored;
    this.idContrato = this.$store.getters.contratoStored;
    this.tituloGraficaRegion = "Progreso Asignación Acomodaciones";

    this.loadData();
  },

  methods: {
    chartData() {
      let data = [];
      data.push({
        avances: "Cantidad",
        "Acomodaciones Solicitadas": this.datosGrafico.acomodacionesSolicitadas,
        "Acomodaciones Asignadas": this.datosGrafico.acomodacionesAsignadas,
      });
      this.indexChart += 1;
      this.res = data;
    },

    filterGra() {
      this.loadDataFiltro();
    },
    clear() {
      this.nivelValue = "";
      this.regionValue = "";
      this.comunaValue = "";
      this.loadData();
    },

    async loadDataFiltro() {
      this.loading = true;
      this.datosGrafico = null;
      this.itemsDocumento = [];
      this.datosGrafico = await this.loadFilterGrafica();
      this.itemsDocumento = await this.loadFilter();

      if (this.datosGrafico != null) {
        this.chartData();
      }

      if (this.itemsDocumento.length > 0) {
        this.loadRegionSelect();
        this.loadComunaSelect();
        this.loadNivelSelect();
      }
      this.loading = false;
    },

    async loadData() {
      this.loading = true;
      this.datosGrafico = null;
      this.itemsDocumento = await this.loadFilter();
      this.datosGrafico = await this.loadFilterGrafica();

      if (this.datosGrafico != null) {
        this.chartData();
      }
      if (this.itemsDocumento.length > 0) {
        this.loadRegionSelect();
        this.loadComunaSelect();
        this.loadNivelSelect();
      }
      this.loading = false;
    },

    loadComunaSelect() {
      let reg = [];
      this.itemsDocumento.forEach(function (d) {
        if (d.comuna != null) {
          let index = reg.findIndex((x) => x.code == d.comuna.id);
          if (index === -1) {
            if (d.comuna != null && d.comuna != "") {
              reg.push({
                name: d.comuna.nombre,
                code: d.comuna.id,
              });
            }
          }
        }
      });
      this.comunaSelect = reg;
    },
    loadNivelSelect() {
      let reg = [];
      this.itemsDocumento.forEach(function (d) {
        if (d.nivel != null) {
          let index = reg.findIndex((x) => x.code == d.nivel.id);
          if (index === -1) {
            if (d.nivel != null && d.nivel != "") {
              reg.push({
                name: d.nivel.descripcion,
                code: d.nivel.codNivelAce,
              });
            }
          }
        }
      });
      this.nivelSelect = reg;
    },
    loadRegionSelect() {
      let reg = [];
      this.itemsDocumento.forEach(function (d) {
        if (d.comuna.idRegion != null) {
          let index = reg.findIndex((x) => x.code == d.region.id);
          if (index === -1) {
            if (d.region != null && d.region != "") {
              reg.push({
                name: d.region.nombre,
                code: d.region.id,
              });
            }
          }
        }
      });
      this.regionSelect = reg;
    },

    async loadFilter() {
      let proceso = this.$store.getters.proSelectedStored;
      let idContrato = this.$store.getters.contratoStored;

      this.body = {
        idRegion:
          this.regionValue && this.regionValue != null
            ? this.regionValue
            : null,
        idComuna:
          this.comunaValue && this.comunaValue != null
            ? this.comunaValue
            : null,
        idNivel:
          this.nivelValue && this.nivelValue != null ? this.nivelValue : null,

        proceso: proceso,
        idContrato: idContrato,
      };
      return await axios

        .post("/acomodaciones/filter", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },
    async loadFilterGrafica() {
      let proceso = this.$store.getters.proSelectedStored;
      let idContrato = this.$store.getters.contratoStored;

      this.body = {
        idRegion:
          this.regionValue && this.regionValue != null
            ? this.regionValue
            : null,
        idComuna:
          this.comunaValue && this.comunaValue != null
            ? this.comunaValue
            : null,
        idNivel:
          this.nivelValue && this.nivelValue != null ? this.nivelValue : null,

        proceso: proceso,
        idContrato: idContrato,
      };
      return await axios

        .post("/acomodaciones/grafica", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },
    downloadComplete() {
      let filename = "REPORTE_ACOMODACIONES.xlsx";

      axios({
        url: "/acomodaciones/downloadReporte/" + this.idContrato,
        method: "GET",
        responseType: "blob",
      })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
  },
};
</script>
